import { EnvironmentInstance, EnvironmentName, TenantId } from 'src/app/_core/constants/EnvironmentConst';
import { Environment } from 'src/app/_core/models/IEnvironment';

export const environment: Environment = {
  name: EnvironmentName.ENVIRONMENTNAME,
  tenantId: TenantId.TENANTID,
  environmentInstance: EnvironmentInstance.ENVIRONMENTINSTANCE,
  defaultLanguage: 'CONSTANT_DEFAULTLANGUAGE',
  appVersion: require('../../package.json').version,
  production: false,
  url: 'CONSTANT_URL',
  server: 'CONSTANT_SERVER',
  authServer: 'CONSTANT_AUTHSERVER',
  mattermostUrl: 'CONSTANT_MATTERMOSTURL',
  placesApiKey: 'CONSTANT_PLACESAPIKEY',
  recaptchaApiKey: 'CONSTANT_RECAPTCHAKEY',
  authBackground: 'CONSTANT_AUTHBACKGROUND',
  whiteLogo: 'CONSTANT_WHITELOGO',
  blackLogo: 'CONSTANT_BLACKLOGO',
  favicon: 'CONSTANT_FAVICON',
  termsOfUse: 'CONSTANT_TERMSOFUSE',
  privacyPolicy: 'CONSTANT_PRIVACYPOLICY',
  emailAddress: 'CONSTANT_EMAILADDRESS',
  hasCause: true,
  hasCodeOfConduct: true,
  isEnglishDefault: true,
  unleashConfig: {
    clientKey: 'CONSTANT_UNLEASHCLIENTKEY',
    url: 'CONSTANT_UNLEASHURL',
  },
  homePage: 'home',
};
